import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { MatchingFile } from '../../core/_models'
import { KTIcon } from '../../../../../_metronic/helpers'
import { EFileStatus } from '../../../../../types/enums'

/**
 * Статус чека и кнопки решения по нему — одинаково в активной очереди, в завершённых
 * и в журнале диспутов.
 *
 * `canManageBills` решает только видимость кнопок; сам факт, что решение по чеку на
 * завершённом тикете не меняет его исход, живёт на бэкенде.
 */
export const BillStatusBadge = ({
  bill,
  handleVerifyBill,
  handleRejectBill,
  canManageBills,
}: {
  bill?: MatchingFile
  handleVerifyBill: () => void
  handleRejectBill: () => void
  canManageBills: boolean
}) => {
  const intl = useIntl()

  const status = useMemo(() => {
    switch (bill?.status) {
      case EFileStatus.REJECTED:
        return (
          <span className='text-muted'>
            {intl.formatMessage({ id: 'receipt.status.REJECTED' })}
          </span>
        )
      case EFileStatus.VERIFIED:
        return (
          <span className='text-muted'>
            {intl.formatMessage({ id: 'receipt.status.VERIFIED' })}
          </span>
        )
      case EFileStatus.PROCESSING:
        return canManageBills ? (
          <BillControls
            bill={bill}
            handleVerifyBill={handleVerifyBill}
            handleRejectBill={handleRejectBill}
          />
        ) : (
          <span>{intl.formatMessage({ id: 'receipt.status.PROCESSING' })}</span>
        )
      default:
        return (
          <span className='text-muted'>
            {intl.formatMessage({ id: 'receipt.status.NO_RECEIPT' })}
          </span>
        )
    }
  }, [bill, canManageBills, handleVerifyBill, handleRejectBill, intl])

  return status
}

const BillControls = ({
  bill,
  handleVerifyBill,
  handleRejectBill,
}: {
  bill: MatchingFile
  handleVerifyBill: () => void
  handleRejectBill: () => void
}) => {
  return (
    <>
      <button
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
        onClick={handleVerifyBill}
        title={`Подтвердить чек #${bill?.id}\n${bill?.token || ''}`}
        disabled={!bill}
      >
        <KTIcon
          className={`fs-1 ${bill ? 'text-success' : 'text-muted'}`}
          iconName='check-circle'
        />
      </button>
      <button
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
        onClick={handleRejectBill}
        title={`Отклонить чек #${bill?.id}\n${bill?.token || ''}`}
        disabled={!bill}
      >
        <KTIcon className={`fs-1 ${bill ? 'text-danger' : 'text-muted'}`} iconName='cross-circle' />
      </button>
    </>
  )
}
